// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a7ee753","453":"4847b3ee","667":"14c81ac2"}[chunkId] + ".chunk.js";
};